import {formatNumberThousands} from '@specials/utils';

import {DeclineUtils} from './DeclineUtil';

export enum TimeFormat {
  Full = 'full',
  Short = 'short',
  Adaptive = 'adaptive',
}

const minCount = 60;
const secCount = 60;
const hoursCount = 24;

export class FormatUtils {
  static formatTime(time: number, timeFormat?: TimeFormat): string {
    const days = Math.trunc(time / 3600 / hoursCount);
    const hours = FormatUtils.pad(Math.trunc((time / 3600) % hoursCount));
    const mins = FormatUtils.pad(Math.trunc((time / minCount) % minCount));
    const seconds = FormatUtils.pad(Math.trunc(time % secCount));

    switch (timeFormat) {
      case TimeFormat.Full: {
        return days
          ? `${days} ${DeclineUtils.declineDays(days)}, ${hours}:${mins}:${seconds}`
          : `${hours}:${mins}:${seconds}`;
      }

      case TimeFormat.Short: {
        return `${hours}:${mins}`;
      }

      case TimeFormat.Adaptive: {
        return hours !== '00' ? `${hours}:${mins}` : `${mins}:${seconds}`;
      }

      default: {
        return `${hours}:${mins}`;
      }
    }
  }

  static formatNumberByDigits(data: string | number, startFormatFromLength = 5): string {
    const normalizedData = `${data}`.replace(/\s/g, '');

    if (normalizedData.length < startFormatFromLength) return normalizedData;

    return formatNumberThousands(Number(normalizedData));
  }

  static pad(n: number): string {
    if (n >= 10) {
      return n.toString();
    }

    if (n < 0) {
      return n.toString();
    }

    return '0' + n;
  }
}
